import React, { useState } from "react";
import Buttons from "../../components/Elements/Buttons";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    number: "",
    email: "",
    address: "",
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.number.trim()) newErrors.number = "Number is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Invalid email format";
    if (!formData.address.trim()) newErrors.address = "address is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    console.log("Form Data:", formData);
    alert("Form submitted successfully!");
    setFormData({ name: "", number: "", email: "", address: "" });
    setErrors({});
  };

  return (
    <div className="relative">
      {/* Background Image */}
      <img
        className="w-full h-[612px] max-lg:h-[60vh] object-cover"
        src="/assets/home-contact-bg.jpg"
        alt="Contact Us Background"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-[rgba(103,20,45,0.2)]"></div>

      {/* Form Section */}
      <div className="absolute inset-0 flex items-center justify-start max-lg:justify-center px-20 max-lg:px-6">
        <form
          onSubmit={handleSubmit}
          className="bg-white rounded-lg shadow-lg p-8 w-[400px] max-w-[90%]"
        >
          <h2 className="text-2xl font-semibold font-source-serif-4 mb-6">
            Contact Us
          </h2>

          {/* Name */}
          <div className="mb-4">
            <input
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleChange}
              className="w-full border border-gray-300 font-source-serif-4 rounded-md p-2 focus:outline-none"
            />
            {errors.name && (
              <p className="text-red-500 text-xs mt-1">{errors.name}</p>
            )}
          </div>

          <div className="mb-4">
            <input
              type="number"
              name="number"
              placeholder="Number"
              value={formData.number}
              onChange={handleChange}
              className="w-full border border-gray-300 font-source-serif-4 rounded-md p-2 focus:outline-none"
            />
            {errors.number && (
              <p className="text-red-500 text-xs mt-1">{errors.number}</p>
            )}
          </div>

          {/* Email */}
          <div className="mb-4">
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              className="w-full border border-gray-300 font-source-serif-4 rounded-md p-2 focus:outline-none"
            />
            {errors.email && (
              <p className="text-red-500 text-xs mt-1">{errors.email}</p>
            )}
          </div>

          {/* address */}
          <div className="mb-4">
            <input
              type="text"
              name="address"
              placeholder="Address"
              value={formData.address}
              onChange={handleChange}
              className="w-full border border-gray-300 font-source-serif-4 rounded-md p-2 focus:outline-none"
            ></input>
            {errors.address && (
              <p className="text-red-500 text-xs mt-1">{errors.address}</p>
            )}
          </div>

          {/* Submit */}
          <Buttons
            type="submit"
            buttonText={"Send"}
            color="red"
            textColor="white"
          />
          {/* <button
            type="submit"
            className="bg-[#67142D] text-white px-4 py-2 rounded-md hover:bg-[#4d0f22] transition w-full"
          >
            Send
          </button> */}
        </form>
      </div>
    </div>
  );
};

export default ContactUs;
